export default __webpack_public_path__ + "static/media/21t.cc880182.jpg";